import {
  insertSystemUser,
  editSystemUser,
  getSystemUserById,
  getAllSystemUsers,
  deleteSystemUser,
  getAllSecurityRoles,
} from "../../../api/divvy-systemUsers";

const manageSystemUsers = {
  namespaced: true,
  state: () => ({
    passwordCheckFailed: false,
    systemUsers: [],
    securityRoles: [],
    user: {
      id: null,
      username: "",
      password: "",
      auth_num: null,
      full_name: "",
      phone: "",
      ext: "",
      email: "",
    },
  }),
  getters: {
    userById: (state) => state.user,
    allSystemUsers: (state) => state.systemUsers,
    allSecurityRoles: (state) => state.securityRoles,
    passwordCheckFailed: (state) => state.passwordCheckFailed,
  },
  actions: {
    fetchAllSystemUsers({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAllSystemUsers(data)
          .then((resp) => {
            commit("SET_SYSTEM_USERS", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, "from getAllSystemUsers");
          });
      });
    },

    fetchSystemUserById({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSystemUserById(params)
          .then((resp) => {
            console.log(resp, "from getSystemUserbyId");
            commit("SET_SYSTEM_USER_BY_ID", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, "from getSystemUserbyId");
          });
      });
    },

    addSystemUser({ commit }, form) {
      return new Promise((resolve, reject) => {
        insertSystemUser(form)
          .then((resp) => {
            resolve(resp);
          })
          .catch(() => {
            console.log("error from add system user action");
          });
      });
    },

    updateSystemUser({ commit }, form) {
      return new Promise((resolve, reject) => {
        editSystemUser(form)
          .then((resp) => {
            console.log(resp, "from edit system user action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from edit system user action");
          });
      });
    },
    removeSystemUser({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteSystemUser(id)
          .then((resp) => {
            console.log(resp, "from delete system user action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from delete system user action");
          });
      });
    },
    fetchAllSecurityRoles({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAllSecurityRoles(params)
          .then((resp) => {
            commit("SET_SECURITY_ROLES", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, "from fetchAllSecurityRoles");
          });
      });
    },
  },
  mutations: {
    SET_SYSTEM_USERS(state, data) {
      state.systemUsers = data;
    },
    SET_SYSTEM_USER_BY_ID: (state, user) => {
      state.user = user;
    },
    SET_SECURITY_ROLES(state, data) {
      state.securityRoles = data;
    },
    SET_PASSWORD_CHECK(state, data) {
      state.passwordCheckFailed = data;
    },
  },
};

export default manageSystemUsers;
